import React, { useState } from "react";
import axios from "axios";
import { UserProfileData } from "../FetchAPI";
// import NotifyMessage from "../Others/NotifyMessage";
import { useLocation, useNavigate } from "react-router-dom";
import NotifyMessageNoReload from "../Others/NotifyMessageNoReload";
import { useAuth } from "../../Store/AuthContext";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";
// const userID = localStorage.getItem("userid");

export default function CommunityAnswersForm({ RendomTokenfetch, QuestionID }) {
  const { userID } = useAuth();

  const [userData] = UserProfileData(RendomTokenfetch);
  const userRoll = userData.role;
  const navigate = useNavigate();
  const location = useLocation();

  const [answers, setanswers] = useState("");
  const [videoUrl, setvideoUrl] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    // Check if user is logged in
    if (localStorage.getItem("userid") === null) {
      NotifyMessageNoReload(
        "Please login to submit your question.",
        "danger",
        true
      );
      navigate("/login", { state: { from: location.pathname } }); // Redirect to login with return path
      return;
    }
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("role_id", userRoll);
    fdata.append("question_id", QuestionID);
    if (videoUrl) {
      fdata.append("video", videoUrl);
    }
    fdata.append("answer", answers);

    axios
      .post(`${WebsiteAPIurl}community_AnswerAdd`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (answers) {
          if (response.data.Status === "0") {
            // NotifyMessage(response.data.message, "danger", true);
            NotifyMessageNoReload(response.data.message, "danger", true);
          }
          if (response.data.Status === "1") {
            NotifyMessageNoReload(response.data.message, "success", true);
            setvideoUrl("");
            setanswers("");
          }
        } else {
        }
      });
  };
  return (
    <form className="was-validated AskfreeQuestionForm" onSubmit={handleSubmit}>
      <div className="row">
        <div className="form-group col-lg-12 col-md-12 mb-4">
          <textarea
            rows={3}
            name="answers"
            id="answers"
            value={answers}
            onChange={(e) => setanswers(e.target.value)}
            className="form-control"
            placeholder="Answers (Limit 500 characters)"
            required
          ></textarea>
        </div>

        <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
          <input
            id="videourl"
            value={videoUrl}
            onChange={(e) => setvideoUrl(e.target.value)}
            className="form-control"
            placeholder="Video Url"
          />
        </div>

        <div className="col-lg-6 col-md-6 col-sm-12 text-end mb-3">
          <button type="submit" className="theme-btn btn-style-three submitbtn">
            Submit
          </button>
        </div>
      </div>
    </form>
  );
}
